import { useEffect, useRef, useState } from "react";
import recordingMic from "../../assets/homepage/enquiry/Mic.png";

const SoundRecorder = ({ selectedOption, attachments, width = 350 }) => {
  const audioChuck = useRef([]);
  const [recordings, setRecordings] = useState("");
  const [recordState, setRecordState] = useState(false);
  const mediaRecorderRef = useRef(null);

  const startRec = async () => {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });

    const mediaRecorder = new MediaRecorder(stream);

    mediaRecorder.ondataavailable = (e) => {
      if (e.data.size > 0) {
        audioChuck.current.push(e.data);
      }
    };

    mediaRecorder.onstop = async () => {
      const audioBlob = new Blob(audioChuck.current, { type: "audio/wav" });
      attachments.push(audioBlob);

      const audioUrl = URL.createObjectURL(audioBlob);
      setRecordings(audioUrl);
    };

    mediaRecorderRef.current = mediaRecorder;
    mediaRecorder.start();
  };

  const stopRec = () => {
    if (
      mediaRecorderRef.current &&
      mediaRecorderRef.current.state === "recording"
    ) {
      mediaRecorderRef.current.stop();
    }
  };

  useEffect(() => {
    if (recordState && selectedOption === "addImages") {
      stopRec();
      attachments.pop();
      setRecordState(!recordState);
    }

    setTimeout(() => {
      if (selectedOption === "addImages") setRecordings("");
    }, 1);
  }, [selectedOption]);

  return (
    <>
      {selectedOption === "recordRequirement" && !recordings && (
        <button
          onClick={startRec}
          type="button"
          // style={{ width }}
          className="rounded-[20px] flex flex-row items-start justify-center"
        >
          <img
            className="h-[27px] w-[27px]"
            src={recordingMic}
            alt="recordingMic"
          />
          {!recordState ? (
            <p
              onClick={() => {
                startRec();
                setRecordState(!recordState);
              }}
              className="font-semibold text-[14px] text-[#FF9653] leading-[28px]"
            >
              Click to start recording
            </p>
          ) : (
            <p
              onClick={() => {
                stopRec();
                setRecordState(!recordState);
              }}
              className="font-[600] text-[14px] text-[#FF9653] leading-[28px] my-auto ml-[4px]"
            >
              Click to stop recording
            </p>
          )}
        </button>
      )}
      {recordings && (
        <div>
          <audio controls src={recordings} />
          <button
            className="text-red-600 text-[12px]"
            onClick={() => {
              setRecordings("");
              attachments.pop();
            }}
          >
            Delete
          </button>
        </div>
      )}
    </>
  );
};

export default SoundRecorder;
